import React from 'react';
import './ApplicationStatus.style.css';
import { InfoCircleFilled } from '@ant-design/icons';

const ApplicationStatus = (props) => {
  /* ===== Route ===== */
  /* ===== Props ===== */
  const {
    icon = <InfoCircleFilled />,
    iconStyle = {
      fontSize: 100,
      color: '#1677FF',
    },
    title,
    titleStyle = {},
    subTitle,
    subTitleStyle = {},
    content,
    contentStyle = {},
  } = props;

  /* ===== State ===== */
  /* ===== Hooks ===== */
  /* ===== Function ===== */
  /* ===== Variable ===== */
  /* ===== Hooks ===== */
  /* ===== Render ===== */
  return (
    <div className="application_layout">
      <div className="application_container">
        <div>
          {React.cloneElement(icon, {
            style: {
              ...iconStyle,
            },
          })}
        </div>
        <h4 style={{ ...titleStyle }}>{title}</h4>
        <p style={{ ...subTitleStyle }}>{subTitle}</p>
        <div style={{ ...contentStyle }}>{content}</div>
      </div>
    </div>
  );
};

export default ApplicationStatus;
